import React, { useState, useEffect } from 'react';

const RejectRequestModal = ({ show, onClose, request, onSubmit }) => {
  const defaultReason = "I'm at capacity and can't accept more birds. You may request a different handler or select rotation for admin placement.";
  const [reason, setReason] = useState(defaultReason);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setReason(defaultReason);
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    try {
      await onSubmit(reason);
      onClose();
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  if (!show) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="modal-backdrop fade show" 
        style={{ zIndex: 1040 }}
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div 
        className="modal fade show" 
        style={{ display: 'block', zIndex: 1050 }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: '2px solid #0b3d91' }}>
              <h5 className="modal-title" style={{ color: '#0b3d91' }}>
                <i className="bi bi-x-circle me-2"></i>
                Reject Request
              </h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                disabled={submitting}
              ></button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                {/* Request Info */}
                <div className="alert alert-light border mb-3">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <strong>{request?.breederName}</strong>
                      <div className="small text-muted mt-1">
                        {request?.breederLoftName}
                      </div>
                    </div>
                    <span className="badge bg-danger">
                      {request?.numberOfBirds} {request?.numberOfBirds === 1 ? 'bird' : 'birds'}
                    </span>
                  </div>
                </div>

                {/* Reason Field */}
                <div className="mb-3">
                  <label htmlFor="rejectionReason" className="form-label fw-bold">
                    Reason for Rejection
                  </label>
                  <textarea
                    id="rejectionReason"
                    className="form-control"
                    rows="4"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    required
                    disabled={submitting}
                    placeholder="Enter reason for rejection..."
                  />
                  <div className="form-text">
                    This reason will be sent to the breeder.
                  </div>
                </div>

                {/* Quick Reason Buttons */}
                <div className="mb-3">
                  <label className="form-label fw-bold small">Quick Reasons:</label>
                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => setReason(defaultReason)}
                      disabled={submitting}
                    >
                      At Capacity
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => setReason("Unable to accommodate at this time. Please try another handler.")}
                      disabled={submitting}
                    >
                      Not Available
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => setReason("Request does not meet handler requirements. Please contact admin for assistance.")}
                      disabled={submitting}
                    >
                      Requirements Not Met
                    </button>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={onClose}
                  disabled={submitting}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="btn btn-danger"
                  disabled={submitting || !reason.trim()}
                >
                  {submitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Rejecting...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-x-circle me-2"></i>
                      Reject Request
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RejectRequestModal;
